import { useState, useEffect, useCallback } from "react";
import axiosInstance, { handleApiError } from "../services/axiosService";

const useFetchData = (url, dependencies = [], initialData = null, headers = {}) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!url) {
      setLoading(false);
      return; // Exit early if URL is not provided
    }

    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get(url, { headers });
      setData(response.data);
    } catch (err) {
      // handleError(err);
      setError(err);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [axiosInstance, url, handleApiError]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData, ...dependencies]);

  return { data, setData, loading, error, refetch: fetchData };
};

export default useFetchData;
